<ion-app>
  <ion-menu contentId="main-content" type="overlay">
    <ion-header>
      <ion-toolbar>
        <ion-title>Menu</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        @for (page of appPages; track page.url) {
          <ion-menu-toggle auto-hide="false">
            <ion-item [routerLink]="page.url" routerLinkActive="selected" [routerLinkActiveOptions]="{exact: true}" lines="none" detail="false">
              <ion-icon slot="start" [name]="page.icon"></ion-icon>
              <ion-label>{{ page.title }}</ion-label>
              @if (page.premium) {
                <ion-icon slot="end" name="star" color="warning" size="small"></ion-icon>
              }
            </ion-item>
          </ion-menu-toggle>
        }
      </ion-list>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
